// RelatedFindingsStrip — CTSK-507. "Also in: Q3 Audit (12) · Receipts (7) ·
// Taxes 2025 (5)": the biggest groups / collections / folders among ALL hits of
// the current search (not just the page), each a button that adds that filter.
// Full-page search only — the header dropdown has no room for it and shows the
// per-row chips instead. Renders nothing without facets (grouping off, facets
// switched off, no hits, or the server skipped them), so it can never show a
// stale or empty bar.

import type { DocumentSearchFacets } from '@captain-tasko/shared';
import { facetEntries, type LabelKind } from './labelChips.js';

export interface RelatedFindingsStripProps {
  facets: DocumentSearchFacets | undefined;
  onPick: (kind: LabelKind, value: string) => void;
}

export function RelatedFindingsStrip({ facets, onPick }: RelatedFindingsStripProps) {
  const entries = facetEntries(facets);
  if (entries.length === 0) return null;
  return (
    <nav className="doc-library__facets" aria-label="Related findings" data-testid="search-facet-strip">
      <span className="doc-library__facets-label">Also in:</span>
      <ul className="doc-library__facets-list">
        {entries.map((e) => (
          <li key={`${e.kind}:${e.value}`}>
            <button
              type="button"
              className={`doc-search__chip doc-search__chip--${e.kind}`}
              data-kind={e.kind}
              title={`${e.title} · ${e.count.toLocaleString()} result${e.count === 1 ? '' : 's'}`}
              onClick={() => onPick(e.kind, e.value)}
            >
              {e.text} <span className="doc-library__facets-count">({e.count.toLocaleString()})</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
